import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AttachmentService } from './api/attachment.service';
import { AuthenticateService } from './api/authenticate.service';
import { BrandService } from './api/brand.service';
import { BrandHomeService } from './api/brandHome.service';
import { CartProductService } from './api/cartProduct.service';
import { CategoryService } from './api/category.service';
import { DocumentService } from './api/document.service';
import { HotDealService } from './api/hotDeal.service';
import { ManufacturerService } from './api/manufacturer.service';
import { NotificationService } from './api/notification.service';
import { OrderService } from './api/order.service';
import { OrderHistoryService } from './api/orderHistory.service';
import { PolicyService } from './api/policy.service';
import { PriceRequestService } from './api/priceRequest.service';
import { ProceedStepService } from './api/proceedStep.service';
import { ProductService } from './api/product.service';
import { ProductRepoService } from './api/productRepo.service';
import { ProductRepoTypeValueService } from './api/productRepoTypeValue.service';
import { ProductTypeService } from './api/productType.service';
import { ProductTypeValueService } from './api/productTypeValue.service';
import { ProductViewedService } from './api/productViewed.service';
import { RegisteredUserService } from './api/registeredUser.service';
import { RepositoryService } from './api/repository.service';
import { RoleService } from './api/role.service';
import { UserAddressService } from './api/userAddress.service';
import { UsersService } from './api/users.service';
import { VoucherService } from './api/voucher.service';
import { WarehouseService } from './api/warehouse.service';
import { SystemSettingService } from './api/systemsettting.service';

import { GoogleAnalyticsService } from './api/googleAnalytics.service';
import { TrackingService } from './api/tracking.service';
import { EquipmentModelService } from './api/equipmentModel.service';
import { EquipmentCompatibleProductService } from './api/equipmentCompatibleProduct.service';
import { PartPackageService } from './api/partPackage.service';
import { AdminEquipmentService } from './api/adminEquipment.service';
import { UnpaidOrderService } from './api/unpaid-order.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    AttachmentService,
    AuthenticateService,
    BrandService,
    BrandHomeService,
    CartProductService,
    CategoryService,
    DocumentService,
    HotDealService,
    ManufacturerService,
    NotificationService,
    OrderService,
    OrderHistoryService,
    PolicyService,
    PriceRequestService,
    ProceedStepService,
    ProductService,
    ProductRepoService,
    ProductRepoTypeValueService,
    ProductTypeService,
    ProductTypeValueService,
    ProductViewedService,
    RegisteredUserService,
    RepositoryService,
    RoleService,
    UserAddressService,
    UsersService,
    VoucherService,
    WarehouseService,
    SystemSettingService,
    GoogleAnalyticsService,
    TrackingService,
    EquipmentModelService,
    EquipmentCompatibleProductService,
    PartPackageService,
    AdminEquipmentService,
    UnpaidOrderService,
  ],
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
